import { useRef } from 'react';

const items = [
  { label: 'Google', score: '4.9' },
  { label: 'Clutch', score: '4.8' },
  { label: 'Yelp', score: '4.9' },
  { label: 'Trustpilot', score: '4.8' },
  { label: 'Happy Clients', score: '500+' },
  { label: 'Projects Delivered', score: '1000+' },
];

function MarqueeInner({ hidden }) {
  return (
    <div className="mq-inner" aria-hidden={hidden}>
      {items.map((item, i) => (
        <span key={i}>
          <span className="mq-item">
            <span className="mq-star">★★★★★</span> {item.label} <span className="mq-score">{item.score}</span>
          </span>
          <span className="mq-sep">—</span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  const wrapRef = useRef(null);
  const pause  = () => wrapRef.current?.querySelectorAll('.mq-inner').forEach(el => el.style.animationPlayState = 'paused');
  const resume = () => wrapRef.current?.querySelectorAll('.mq-inner').forEach(el => el.style.animationPlayState = 'running');

  return (
    <div className="mq-wrap" id="tbar" ref={wrapRef} onMouseEnter={pause} onMouseLeave={resume}>
      <div className="mq-track">
        <MarqueeInner hidden={false} />
        <MarqueeInner hidden={true}  />
      </div>
    </div>
  );
}
